import { BasePageData } from '../models/strapi/base-page-data';
import { StrapiHeadline } from '../models/strapi/strapi-headline';
import { StrapiMeta } from '../models/strapi/strapi-meta';
import { StrapiParagraphProps } from '../models/strapi/strapi-paragraph-props';
import { StrapiStage } from '../models/strapi/strapi-stage';
import { StrapiTextSectionProps } from '../models/strapi/strapi-text-section-props';
import { useLanguageDependentDataSSr } from './useLanguageDependentDataSsr.hook';

export const useVariantDetailPage = useLanguageDependentDataSSr<UseVariantDetailPageData>(
    'variant-detail-page'
);

export interface UseVariantDetailPageData extends BasePageData {
    stage: StrapiStage;
    meta: StrapiMeta;
    variantDescription: StrapiHeadline;
    variantAttributes: StrapiHeadline;
    product: StrapiHeadline;
    unlockables: StrapiHeadline;
    samples: StrapiHeadline;
    additionalAttributes: StrapiHeadline;
    legal: StrapiHeadline;
    productAttributes: StrapiHeadline;
    productDescription: StrapiHeadline;
    productOriginators: StrapiHeadline;
    publisherHeadline: StrapiHeadline;
    instanceTableCopyHeadline: string;
    instanceTableStatusHeadline: string;
    instanceTableLastPurchasedForHeadline: string;
    instanceTableCurrentPriceHeadline: string;
    instanceTableBuyButtonText: string;
    instanceTableAuctionButtonText: string;
    instanceTableStatusOpenFixedPrice: string;
    instanceTableStatusReserved: string;
    instanceTableStatusMinting: string;
    instanceTableStatusOpenAuction: string;
    instanceTableCopySeperatorWord: string;
    instanceTableStatusSold: string;
    instancesAccordionHeadline: string;
    stageMetaBoxTitleAuthor: string;
    stageMetaBoxTitlePublisher: string;
    stageMetaBoxTitleCopies: string;
    stageMetaBoxTitleRelease: string;
    loginHeader: StrapiTextSectionProps;
    instanceTableHeader: StrapiHeadline;
    variantWith: StrapiParagraphProps;
    instances: StrapiParagraphProps;
    open: StrapiParagraphProps;
    resetFilter: StrapiParagraphProps;
    moreVariantsHeadline: StrapiHeadline;
    filterAll: string;
    filterOpen: string;
    resale: string;
    mintingCount: string;
    salesEnd: string;
    category: string;
    subCategory: string;
    series: string;
    episode: string;
    genre: string;
    seriesDescription: string;
    seriesNumber: string;
    statusSelectPlaceholder: string;
    stageFileDescription: string;
    tDropHeadline: StrapiHeadline;
    tDropDescription: StrapiParagraphProps;
    breadcrumbHome: string;
    breadcrumbDigitalOriginals: string;
}
